export const RWO_TYPE = {
    NEW: 'rs.homeMain.RWONew',
    CORE: 'rs.homeMain.RWOCore',
    WARRANTY: 'rs.homeMain.RWOWarranty',
    MULTIPLE: 'rs.homeMain.RWOMultiple',
};

export const RWO_TYPE_DEFAULT = 'NEW';
